module.exports = __webpack_public_path__ + "static/9-cdebe35a9ca3b2440452339d9fe6d901.webp";